import React from 'react';
import { LazyComponent } from '@fiverr-private/ui_utils';
import { SkeletonLoading } from '@fiverr-private/identification_core';
import { useSignUpContext } from '../../SignUpContext';
import { logError } from '../../../utils/logError';

const lazyImport = () => import(/* webpackChunkName: 'LazyInvitationStep' */ './InvitationStep');

export const LazyInvitationStep = () => {
    const { isInvitationFlow } = useSignUpContext();

    return (
        <LazyComponent
            lazyImport={lazyImport}
            shouldImport={isInvitationFlow}
            placeholder={<SkeletonLoading loading maxHeight="100%" />}
            onError={(error) => logError({ message: 'Failed to lazy load InvitationStep', error })}
        />
    );
};
